import { __ } from "@wordpress/i18n";

const LABELS = [
	{ label: __("All Icons", "magazine-blocks"), value: "any" },
	{
		label: __("Magazine Blocks", "magazine-blocks"),
		value: "magazine-blocks",
	},
	{
		label: __("Font Awesome - Regular", "magazine-blocks"),
		value: "regular",
	},
	{
		label: __("Font Awesome - Solid", "magazine-blocks"),
		value: "solid",
	},
	{
		label: __("Font Awesome - Brands", "magazine-blocks"),
		value: "brands",
	},
];

export { LABELS };
